var pic1 = require('../../../assets/images/gallery/pic1.jpg');
var pic2 = require('../../../assets/images/gallery/pic2.jpg');
var pic3 = require('../../../assets/images/gallery/pic3.jpg');
var pic4 = require('../../../assets/images/gallery/pic4.jpg');
var pic5 = require('../../../assets/images/gallery/pic5.jpg');
var pic6 = require('../../../assets/images/gallery/pic6.jpg');
var pic7 = require('../../../assets/images/gallery/pic7.jpg');
var pic8 = require('../../../assets/images/gallery/pic8.jpg');
var pic9 = require('../../../assets/images/gallery/pic9.jpg');
var pic10 = require('../../../assets/images/gallery/pic10.jpg');
var pic11 = require('../../../assets/images/gallery/pic11.jpg');
var pic12 = require('../../../assets/images/gallery/pic12.jpg');
const DataGalleryGridPage = [
 {    
	id: 1,
    image: pic1,
	
    name: "Group Study",
    category: "Group Study",   
    description: "Group study is a method for learning where students collaborate and engage in knowledge sharing and problem-solving. Here are some benefits of studying in a group."	
  },
  {
    id: 2,
    image: pic2,
	
    name: "Fun and Engaging Educational Activities for Kids",
    category: "Fun",
    description: "Our team has decades of film and tech experience. We know how to deliver amazing results every time."

  },
  {
    id: 3,
    image: pic3,
	
    name: "Music Programs",
    category: "Fun",
    description: "Provide opportunities for students to learn musical instruments, participate in bands or orchestras, and develop their musical talents. "
  },
  {
    id: 4,
    image: pic4,
	
    name: "Math Games",
    category: "Fun",
    description: "Make learning math fun and interactive through games and puzzles."
  },
  {
    id: 5,
    image: pic5,
	
    name: "Debates",
    category: "Group Study",
    description: " Improve critical thinking, communication, and research skills through structured arguments. "
  },
  {
    id: 6,
    image: pic6,
	
    name: "Social awareness",
    category: "Community Events",
    description: "Social awareness is always a necessary skill to have, as it addresses many of the social issues experienced in schools and the larger world. "
  },
  {
    id: 7,
    image: pic7,
	
    name: "Memory Murals",
    category: "Fun",
    description: "Allow students to visually represent their learning experiences and create a lasting memory of the school year."
  },
  {
    id: 8,
    image: pic8,
	
    name: "Reading Clubs",
    category: "Group Study",
    description: "Encourage a love for reading through discussions, book reviews, and literary analysis."
  },
  {
    id: 9,
    image: pic9,
	
    name: "Community Events",
    category: "Community Events",
    description: "Involve students in events like trunk-or-treat or cultural nights to foster a sense of belonging."
  },
  {
    id: 10,
    image: pic10,
	
    name: "Arts and Crafts",
    category: "Arts and Crafts",
    description: "Develop creativity and fine motor skills through activities like painting, drawing, sculpting, or jewelry making. "
  },
  {
    id: 11,
    image: pic11,
	
    name: "Talent Shows",
    category: "Shows",
    description: "Allow students to showcase their talents and build confidence. "
  },
  {
    id: 12,
    image: pic12,
	
    name: "Buildings",
    category: "Building",
    description: "School buildings refer to the physical structures that are designed and constructed for educational purposes."
  }
];

export default DataGalleryGridPage;